import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button, CircularProgress, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { addEvent, getBroadcastChannels, getEvents, getNotificationTemplate } from '../../ReduxStore/NotificationSlice';
import { sanitizeForDisplay } from '../../utils/inputSanitization';

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    control: (provided) => ({
        ...provided,
        minHeight: '54px',
        height: '54px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        height: '54px',
        padding: '0 8px',
    }),
};

const AddEvent = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' },
        { label: 'Mail Management', href: '/mail-management' }
    ];

    const [loadings, setLoading] = useState(true);
    const [notificationTemplateOptions, setnotificationTemplateOptions] = useState([]);
    const [channelOptions, setChannelOptions] = useState([]);
    const [notificationTemplates, setTemaplates] = useState([]);
    const [events, setEvents] = useState([]);
    const [broadcastChannels, setChannels] = useState([]);
    const [selectedtTemplate, setselectedTemplate] = useState(null);
    const [selectedChannel, setselectedChannel] = useState(null);
    const [selectedType, setselectedType] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        category: "",
        description: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const typrOptions = [
        { value: 'system', label: 'System' },
        { value: 'user', label: 'User' }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            name: formData.name,
            category: formData.category,
            description: formData.description,
            type: selectedType.value,
            channel_id: selectedChannel.value,
            template_id: selectedtTemplate.value,
            customer_id: "af33f9117ecb4d8d8def84d6331eebd4"
        }
        console.log("check payload", payload)
        try {
            const action = dispatch(addEvent(payload));
            const response = await action.unwrap();
            console.log("check reposnse of  channel post--", response.result);
            if (response.StatusCode === 201) {
                toast.success(`Event added Successfully!`)
                getEvent();
                setselectedChannel(null)
                setselectedTemplate(null)
                setselectedType(null)
                setFormData({
                    name: "",
                    category: "",
                    description: ""
                })

            }
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    };


    useEffect(() => {

        if (notificationTemplates.length > 0) {
            const notificationTemplatesList = notificationTemplates && notificationTemplates.map(item => ({
                value: item.id,
                label: item.name,
            }));

            if (notificationTemplatesList) {
                setnotificationTemplateOptions(notificationTemplatesList.map(item => ({
                    value: item.value,
                    label: item.label,
                })));
            }
        }

        if (broadcastChannels.length > 0) {
            const channelList = broadcastChannels && broadcastChannels.map(item => ({
                value: item.id,
                label: sanitizeForDisplay(item.name),
            }));

            if (channelList) {
                setChannelOptions(channelList.map(item => ({
                    value: item.value,
                    label: item.label,
                })));
            }
        }

    }, [broadcastChannels, notificationTemplates]);

    const getChannels = async () => {
        try {
            const action = dispatch(getBroadcastChannels(`?customer_id=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            console.log("getChannels", res.result);
            if (res.result) {
                setChannels(res.result);
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    const getTemplates = async () => {
        try {
            const action = dispatch(getNotificationTemplate(`?customer_id=af33f9117ecb4d8d8def84d6331eebd4`));
            const res = await action.unwrap();
            console.log("notificationTemplates--", res.result);
            if (res.result) {
                setTemaplates(res.result.notification_template);
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    const getEvent = async () => {
        try {
            const action = dispatch(getEvents(`?type=user`));
            const res = await action.unwrap();
            console.log("Eventsss--======", res.result);
            if (res.result) {
                setEvents(res.result);
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await getChannels();
            await getTemplates();
            await getEvent();
            setLoading(false);
        };
        fetchData();
    }, [])

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <ResponsiveTypography>
                        Add Event
                    </ResponsiveTypography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Add Event" />
                </Box>
                <Box className="add-checkpoint" mb={3}>
                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Add Event
                            </Typography>
                        </Grid>
                    </Grid>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={3} alignItems="center">
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Name"
                                    name="name"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.name}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Category"
                                    name="category"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.category}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Description"
                                    name="description"
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    value={formData.description}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Select
                                    styles={customStyles}
                                    options={typrOptions}
                                    placeholder="Select Type"
                                    isSearchable
                                    isClearable
                                    value={selectedType}
                                    menuPlacement="auto"
                                    onChange={setselectedType}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Select
                                    styles={customStyles}
                                    options={channelOptions}
                                    placeholder="Select Broadcast Channel"
                                    isSearchable
                                    value={selectedChannel}
                                    isClearable
                                    menuPlacement="auto"
                                    onChange={setselectedChannel}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Select
                                    styles={customStyles}
                                    options={notificationTemplateOptions}
                                    placeholder="Select Template"
                                    isSearchable
                                    isClearable
                                    value={selectedtTemplate}
                                    menuPlacement="auto"
                                    onChange={setselectedTemplate}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    size="medium"
                                    // fullWidth
                                    // color="primary"
                                    style={{ backgroundColor: 'green', color: 'white' }}
                                >
                                    Save Event
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>


                <Box className="add-checkpoint">
                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Event List
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} alignItems='center'>
                        {/* <Grid item xs={2} sm={1}>
                            <h4>Sr.no.</h4>
                        </Grid> */}
                        <Grid item xs={3} sm={2}>
                            <h4>Name</h4>
                        </Grid>
                        <Grid item xs={3} sm={1}>
                            <h4>Type</h4>
                        </Grid>
                        <Grid item xs={3} sm={2}>
                            <h4>Category</h4>
                        </Grid>
                        <Grid item xs={3} sm={3}>
                            <h4>Description</h4>
                        </Grid>
                        <Grid item xs={3} sm={2}>
                            <h4>Channel Name</h4>
                        </Grid>
                        <Grid item xs={3} sm={2}>
                            <h4>Template Name</h4>
                        </Grid>
                    </Grid>
                    <hr />
                    {loadings ? (
                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        events.length > 0 && events.map((item, index) => (
                            <Grid container spacing={3} key={index} alignItems='center'>
                                {/* <Grid item xs={2} sm={1}>
                                    {index + 1}
                                </Grid> */}
                                <Grid item xs={3} sm={2}>
                                    {item.name}
                                </Grid>
                                <Grid item xs={3} sm={1}>
                                    {item.type}
                                </Grid>
                                <Grid item xs={3} sm={2}>
                                    {item.category}
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    {item.description}
                                </Grid>
                                <Grid item xs={3} sm={2}>
                                    {item.channel_name}
                                </Grid>
                                <Grid item xs={3} sm={2}>
                                    {item.template_name}
                                </Grid>
                            </Grid>
                        ))
                    )}
                    <hr />
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default AddEvent;
